class TipoProdutoEnum {
    constructor(cod, desc) {
        this.cod = cod;
        this.desc = desc;
    }

    static fromcod(cod) {
        return Object.values(TipoProdutoEnum).find(status => status.cod === cod);
    }

    static fromDesc(desc) {
        return Object.values(TipoProdutoEnum).find(status => status.desc === desc);
    }
}

TipoProdutoEnum.PERMANENTE = new TipoProdutoEnum(1, "PERMANENTE");
TipoProdutoEnum.CONSUMO = new TipoProdutoEnum(2, "CONSUMO Movimentação de Item Bem permanente");

export default TipoProdutoEnum;